import { initLogRocketStepOne } from './initLogRocketStepOne';
import { initMixpanelStepOne } from './initMixpanelStepOne';

/**
 * Initializes error tracking & session screen recording as early as possible,
 * prior to almost any other app initialization, so that we have the best shot
 * at capturing errors that occur early on, or that occur during the rest of
 * app initialization.
 *
 * This is called "Step One" because it happens before we have loaded the
 * current user & org information. Step two is identifying the user & org in
 * the monitoring tools, and that happens after we've successfully loaded the
 * user & org data. Splitting it into two steps helps us capture errors that
 * might occur while we are loading that first data.
 *
 * Contract: this function call must catch and suppress all errors internally.
 * Callers should call this function without needing a try/catch of their own.
 */
export function initMonitoringStepOne() {
  try {
    initLogRocketStepOne();
  } catch (error) {
    console.error('Error initializing LogRocket step one', error);
  }

  /*
   * TODO no need to initialize mixpanel so early - it should be able to wait.
   *   Only thing holding us back is that some app code calls window.mixpanel
   *   directly on the window and makes that call very early (before the react
   *   app is even mounted).
   */
  try {
    initMixpanelStepOne();
  } catch (error) {
    console.error('Error initializing Mixpanel step one', error);
  }
}
